<template>
    <input :value="value" ref="inputMask" @blur="$emit('blur')" @focus="$emit('focus')">
</template>

<script>
  export default {
    name: 'masked-input',
    props: {
      mask: {
        type: String,
        required: true,
        default: '999999'
      },
      parameters: {
        type: Object,
        default () {
          return {}
        }
      },
      value: {
        type: String,
        default: ''
      }
    },
    mounted () {
      this.maskInit()
    },
    destroyed: function () {
      this.maskDestroy()
    },
    data: function () {
      return {
        isComplete: false
      }
    },
    methods: {
      maskInit () {
        let params = Object.assign(this.parameters, {
          rightAlign: false,
          onBeforeWrite: (event) => {
            if(!!event.target)
            this.$emit('input', event.target.value)
          }
        });

        window.$(this.$refs.inputMask).inputmask(this.mask, params)
      },
      maskDestroy () {
        window.$(this.$refs.inputMask).off().inputmask('remove')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/vue/components/MaskedInput.vue